module.exports = __webpack_public_path__ + "img/public_bath.f8170eb9.svg";